(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["support-faq"] && !Shopify.designMode) return;
  try {
    
  function toggleFaq(element) {
    const allFaqs = document.querySelectorAll('.faq-item');
    allFaqs.forEach((item) => {
      if (item !== element && item.classList.contains('open')) {
        item.classList.remove('open');
      }
    });
    element.classList.toggle('open');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-page"] && !Shopify.designMode) return;
  try {
    
  // Filter functionality for testimonials page
  document.addEventListener('DOMContentLoaded', function () {
    const filterTabs = document.querySelectorAll('.testimonials-page-filter .filter-tab');
    const testimonialCards = document.querySelectorAll('.testimonials-page-card');

    filterTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        // Update active tab
        filterTabs.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');

        const filter = tab.dataset.filter;

        // Filter cards
        testimonialCards.forEach((card) => {
          if (filter === 'all' || card.dataset.product === filter) {
            card.style.display = 'flex';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  // Filter functionality
  document.addEventListener('DOMContentLoaded', function () {
    const filterTabs = document.querySelectorAll('.filter-tab');
    const testimonialCards = document.querySelectorAll('.testimonial-card');

    filterTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        // Update active tab
        filterTabs.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');

        const filter = tab.dataset.filter;

        // Filter cards
        testimonialCards.forEach((card) => {
          if (filter === 'all' || card.dataset.product === filter) {
            card.style.display = 'block';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
